import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useState } from "react";
import { ASSETS_PATH } from "../../constants";
import axiosClient from "../../services/axios-client";

const PopAddEditModel = ({ model, onCloseModel, onUpdateModel, years, uploadAsset }) => {

    const [mdl, setMdl] = useState(model);
    const [modelName, setModelName] = useState('');
    const [modalNameError, setModalNameError] = useState(false);

    

    const onUploadModel = (e) => {
        const filename = uploadAsset(e, (fileName) => { setMdl({ ...mdl, model_file: fileName }) });
    }

    const onRemoveModel = () => {
        setMdl({ ...mdl, model_file: '' })
    }


    const onUploadTodayMap = (e) => {
        const filename = uploadAsset(e, (fileName) => { setMdl({ ...mdl, model_map: fileName }) });
    }

    const onRemoveTodayMap = () => {
        setMdl({ ...mdl, model_map: '' })
    }

    const onUploadYearMap = (e, year) => {
        const filename = uploadAsset(e, (fileName) => {             
            setMdl({ ...mdl, model_history: [...mdl.model_history, { year: year, map: fileName }] }) 
        });
    }

    const onRemoveYearMap = (year) => {
        setMdl({ ...mdl, model_history: mdl.model_history.filter(x => x.year !== year) })
    }

    const onAddMdl = async() => {
        if(mdl.model_name.trim() == ''){
            console.log('model name required');
            setModalNameError(true);
            return;
        }

        const body = { ...mdl, model_history: JSON.stringify(mdl.model_history) };

        const response = await axiosClient.post(`${process.env.REACT_APP_API_URL}/model`, body);

        const mdl1 = { ...mdl, model_id: response.data.insertId}

        setModalNameError(false);
        onUpdateModel(mdl1);
    }

    const onUpdateMdl = async() => {
        if(mdl.model_name.trim() == ''){
            console.log('model name required');
            setModalNameError(true);
            return;
        }

        const body = { ...mdl, model_history: JSON.stringify(mdl.model_history) };

        const response = await axiosClient.put(`${process.env.REACT_APP_API_URL}/model`, body);        

        setModalNameError(false);
        onUpdateModel(mdl);
    }


    return (
        <>
            <div className="pop-background"></div>
            <div className="pop-container">
                <div className="pop-header">
                    Add New Model
                </div>
                <div className="pop-content">
                    <div className="mb-4">
                        <TextField value={mdl.model_name} onChange={(e) => setMdl({ ...mdl, model_name: e.target.value })} label="Model Name" variant="outlined" />
                            {modalNameError && <p style={{color:'red'}}>Model name required</p>}
                    </div>
                    <div className="flex flex-row">
                        {
                            mdl.model_file &&
                            <>
                                <div className="mr-4">{mdl.model_file}</div>
                                <div><Button variant="outlined" onClick={onRemoveModel}>Remove Model</Button></div>
                            </>

                        }
                        {!mdl.model_file && <Button variant="contained" component="label">Upload Model
                            <input
                                type="file"
                                hidden
                                onChange={onUploadModel}
                            /></Button>}
                    </div>
                    <div className="grid grid-cols-3 gap-4 mt-4">
                        <div>
                            {
                                mdl.model_map &&
                                <>

                                    <div className="mr-4">
                                        <img src={`${ASSETS_PATH}/${mdl.model_map}`} />
                                    </div>
                                    <div>
                                        <Button variant="outlined" onClick={onRemoveTodayMap}>Remove Map for Today</Button>
                                        </div>
                                </>
                            }
                            {!mdl.model_map && <Button variant="contained" component="label">Upload Map for today
                                <input
                                    type="file"
                                    hidden
                                    onChange={onUploadTodayMap}
                                />
                            </Button>}
                        </div>
                        {years.map((year, index) =>
                            <div>                                
                                {
                                    mdl.model_history.find(x => x.year === year) !== undefined &&
                                    <>
                                    <div className="mr-4">
                                        <img src={`${ASSETS_PATH}/${mdl.model_history.find(x => x.year === year).map}`} />
                                    </div>
                                    <div>
                                        <Button variant="outlined" onClick={() => onRemoveYearMap(year)}>Remove Map for {year}</Button>
                                    </div>
                                    </>
                                }
                                {
                                    mdl.model_history.find(x => x.year === year) === undefined &&
                                    <Button variant="contained" component="label">Upload Map for {year}
                                    <input
                                        type="file"
                                        hidden
                                        onChange={(e) => onUploadYearMap(e, year)}
                                    />
                                    </Button>
                                }
                            </div>
                        )}


                    </div>
                </div>
                <div className="pop-footer">
                    <Button onClick={onCloseModel}>Close</Button>
                    {mdl.model_id === 0 && <Button onClick={onAddMdl}>Add and Close</Button>}
                    {mdl.model_id !== 0 && <Button onClick={onUpdateMdl}>Update and Close</Button>}
                </div>
            </div>
        </>

    )
}

export default PopAddEditModel;